import React, { useState, ChangeEvent, FormEvent } from "react";
import SimpleReactValidator from "simple-react-validator";

interface FormFields {
  name: string;
  email: string;
  date: string;
  guest: string;
  // meal: string;
  // reason: string;
}

const RSVPFrom: React.FC = () => {
  const [forms, setForms] = useState<FormFields>({
    name: "",
    email: "",
    date: "",
    guest: "",
    // meal: "",
    // reason: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const changeHandler = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();
      setForms({
        name: "",
        email: "",
        date: "",
        guest: "",
        // meal: "",
        // reason: "",
      });
    } else {
      validator.showMessages();
    }
  };

  return (
    <form
      method="post"
      className="contact-validation-active"
      onSubmit={submitHandler}
    >
      <div>
        <input
          value={forms.name}
          type="text"
          name="name"
          onBlur={changeHandler}
          onChange={changeHandler}
          className="form-control"
          placeholder="Nombre Completo"
        />
        {validator.message("name", forms.name, "required|alpha_space")}
      </div>

      <div>
        <input
          value={forms.email}
          type="email"
          name="email"
          onBlur={changeHandler}
          onChange={changeHandler}
          className="form-control"
          placeholder="Correo Electrónico"
        />
        {validator.message("email", forms.email, "required|email")}
      </div>

      <div>
        <select
          onBlur={changeHandler}
          onChange={changeHandler}
          value={forms.guest}
          className="form-control"
          name="guest"
        >
          <option>Número de Invitados</option>
          <option>01</option>
          <option>02</option>
          <option>03</option>
          <option>04</option>
          <option>05</option>
          <option>06</option>
          <option>07</option>
          <option>08</option>
          <option>09</option>
          <option>10</option>
          <option>11</option>
          <option>12</option>
          <option>13</option>
          <option>14</option>
          <option>15</option>
        </select>
        {validator.message("guest", forms.guest, "required")}
      </div>

      {/* <div>
        <input
          value={forms.reason}
          type="text"
          name="reason"
          onBlur={changeHandler}
          onChange={changeHandler}
          className="form-control"
          placeholder="What Will You Be Attending"
        />
        {validator.message("reason", forms.reason, "required")}
      </div> */}

      {/* <div>
        <select
          onBlur={changeHandler}
          onChange={changeHandler}
          value={forms.meal}
          className="form-control"
          name="meal"
        >
          <option>Meal Preferences</option>
          <option>Chicken Soup</option>
          <option>Mutton Kabab</option>
          <option>Chicken BBQ</option>
          <option>Mix Salad</option>
          <option>Beef Ribs</option>
        </select>
        {validator.message("meal", forms.meal, "required")}
      </div> */}

      <div className="submit-area">
        <button type="submit" className="theme-btn">
          RSVP
        </button>
      </div>
    </form>
  );
};

export default RSVPFrom;
